/**
 * useOrganizations — Fetch current user's organizations
 *
 * Uses the jackpot-ops meta endpoint which returns
 * organizations the current user belongs to.
 */

import { useUserOrganizations } from '../api/extensions/useJackpotOps';

export function useOrganizations() {
  return useUserOrganizations();
}
